import React from "react";

export type AttentionIconProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 12,
    height: 12,
  },
  medium: {
    width: 14,
    height: 14,
  },
  large: {
    width: 32,
    height: 32,
  },
};

export const AttentionIcon: JSX.Element & any = React.forwardRef<
  any,
  AttentionIconProps
>((props, ref) => {
  const { size = "medium", width, height, color = "#4A4754" } = props;
  const svgSize = width && height ? { width, height } : sizes[size];

  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7998 9.7117C11.4879 9.7117 10.4316 8.65544 10.4316 7.34354C10.4316 6.03167 11.5035 4.9917 12.7998 4.9917C14.0961 4.9917 15.168 6.04795 15.168 7.35986C15.168 8.67176 14.1117 9.7117 12.7998 9.7117ZM12.7998 5.75986C11.9198 5.75986 11.1998 6.47986 11.1998 7.35986C11.1998 8.23986 11.9198 8.95986 12.7998 8.95986C13.6798 8.95986 14.3998 8.23986 14.3998 7.35986C14.3998 6.47986 13.6798 5.75986 12.7998 5.75986Z"
        fill={color}
        stroke={color}
        strokeWidth="0.25"
      />
      <path
        d="M12.1437 10.2236H11.4237C10.7037 10.2236 10.0156 9.87177 9.60001 9.27989L8.91189 8.33615C9.58376 7.4399 6.52821 5.66431 7.85563 4.70431C8.49563 4.24057 9.11938 5.15244 9.61563 5.29618C9.8875 5.37618 10.5756 5.39243 10.7519 5.13618C11.0556 4.75244 10.5281 4.49618 10.3519 4.17618V4.15993C10.2719 3.58368 9.93563 3.15181 9.52001 2.97619C9.29627 2.87994 8.81627 1.47245 8.76814 1.07251C8.43189 1.36064 7.95189 1.80877 8.11189 2.28877C8.14376 2.35252 8.17564 2.43252 8.20814 2.49689C8.24001 2.57689 8.19189 2.67315 8.11189 2.72064C7.95189 2.80064 7.77563 2.81689 7.58376 2.80064C7.12002 2.89689 6.49563 2.84876 6.19189 2.92876C4.16005 3.48876 3.47189 5.34508 3.40821 7.31244C3.04008 7.07244 0.608207 6.3687 0.831887 6.9287C0.928137 7.13683 2.04814 7.53683 2.20814 7.58495C2.83189 7.82495 3.32814 8.2087 3.71189 8.7687C4.38376 9.76057 3.82376 10.2568 4.08002 11.0887C4.27189 11.7124 5.23189 12.8005 5.9037 12.7369C6.44744 12.6887 5.91994 11.8569 5.64744 11.505C4.91118 10.5612 5.83931 10.0331 5.83931 8.91315V8.65689L7.31118 10.7532C7.96744 11.6651 8.31931 12.7532 8.31931 13.8732L8.31994 15.2001H9.08806V13.8882C9.08806 12.592 8.68806 11.3764 7.95181 10.3201L5.83997 7.37638L5.11997 6.35263C4.95997 6.12889 4.99184 5.80889 5.21622 5.63263C5.32809 5.53639 5.48809 5.48888 5.63247 5.50451C5.77622 5.52076 5.9206 5.60076 6.0006 5.72825L6.44873 6.33638L8.95993 9.72822C9.51993 10.512 10.4481 10.992 11.4081 10.992H12.1281C13.3762 10.992 14.3999 12.0157 14.3999 13.2638V15.2001H15.1681V13.2638C15.1681 11.5838 13.8081 10.2238 12.1437 10.2238L12.1437 10.2236Z"
        fill={color}
        stroke={color}
        strokeWidth="0.25"
      />
    </svg>
  );
});

AttentionIcon.displayName = "AttentionIcon";
